import { useSelector } from 'react-redux';
import { getShowConfirmationPage } from '../../../selectors/tools';
import DTPartiallyRefundItemsThenSendMacroNode from '../NodeGroups/DTCopyTextSendMacro/DTPartiallyRefundItemsThenSendMacroNode/DTPartiallyRefundItemsThenSendMacroNode';

const PartiallyRefundItemsThenSendMacro = () => {
  const showConfirmationPage = useSelector(getShowConfirmationPage);

  return (
    <DTPartiallyRefundItemsThenSendMacroNode
      showConfirmation={showConfirmationPage}
      message={'The order has been partially refunded'}
    />
  );
};

export default PartiallyRefundItemsThenSendMacro;
